<div class="row">
  <div class="col-12">
    <div class="home-details">
      <h5 class="home-title">{{category | titlecase}}</h5>
      <p class="home-subtitle">List of all {{category}} pages</p>
    </div>
  </div>
</div>

<mat-tab-group [selectedIndex]="activeTab" (selectedIndexChange)="changeRoute($event)" class="mt-3">
  @for (tab of tabOptions[type]; track tab) {
    <mat-tab [label]="tab.label"></mat-tab>
  }
</mat-tab-group>
